import localFont from 'next/font/local';

const primary = localFont({
  src: [
    { path: './fonts/poppins-light-webfont.woff2', weight: '300', style: 'normal' },
    { path: './fonts/poppins-regular-webfont.woff2', weight: '400', style: 'normal' },
    { path: './fonts/poppins-medium-webfont.woff2', weight: '500', style: 'normal' },
    { path: './fonts/poppins-semibold-webfont.woff2', weight: '600', style: 'normal' },
    { path: './fonts/poppins-bold-webfont.woff2', weight: '700', style: 'normal' },
  ],
  variable: '--font-primary',
  preload: false,
});

export const fonts = {
  primary,
};
